module.exports = __webpack_public_path__ + "img/cod.cf69713c.svg";